{
  "intro": "Servers of one \"spread\" group run on different physical hosts: one host failing affects at most one of them. Useful for database replicas and several copies of a service. Groups are free.",
  "empty": "No placement groups yet",
  "emptyLead": "Create a group and add the servers that must not end up on one host — a primary and its standby, for example.",
  "create": "Create group",
  "createLead": "A \"spread\" group: its servers are kept on different hosts.",
  "createSubmit": "Create group",
  "created": "Group {{name}} created",
  "name": "Name",
  "nameHint": "For example by service: web, db.",
  "kind": "Type",
  "spread": "Spread — on different hosts",
  "servers": "Servers",
  "count": "{{count}} of {{max}}",
  "noServers": "Empty so far",
  "free": "Free",
  "createdAt": "Created",
  "labels": "Labels",
  "labelsHint": "One per line: key=value.",
  "labelsInvalid": "Line {{line}}: key and value take up to 63 letters, digits, dots, hyphens and underscores.",
  "add": "Add server",
  "addTitle": "Add a server to {{name}}",
  "addLead": "The server must be powered off: Hetzner places it on a fitting host when it starts next. Up to {{max}} servers per group, one group per server.",
  "adding": "Adding {{server}} to {{name}}",
  "remove": "Remove server",
  "removeTitle": "Remove a server from {{name}}",
  "removeLead": "The server keeps running as it is; it just stops counting for the group's placement.",
  "removing": "Removing {{server}} from {{name}}",
  "server": "Server",
  "chooseServer": "Choose a server",
  "edit": "Name and labels",
  "editTitle": "Group {{name}}",
  "delete": "Delete",
  "deleteTitle": "Delete group {{name}}?",
  "deleteLead": "The group has no servers; deleting it changes nothing on any server.",
  "deleted": "Group {{name}} deleted",
  "why": {
    "running": "not powered off",
    "inGroup": "in group {{group}}",
    "here": "in this group already",
    "full": "The group has {{max}} servers already, the most it can take.",
    "empty": "The group has no servers.",
    "notEmpty": "Remove all servers from the group first."
  },
  "serverFact": "Placement group",
  "serverNone": "None",
  "price": "Per month"
}
